import { city } from "ca-plateform-carrier-report-domain";

export interface CarrierReportModeIncidentState
  extends city.colisactiv.platform.carrier.report.domain.ModeIncidentState {}

class ModeIncidentStateValues extends city.colisactiv.platform.carrier.report
  .domain.ModeIncidentStateValues {}

export const carrierReportModeIncidentStateValues = new ModeIncidentStateValues();
